import { RouteObject } from '@rocketlane/rocket-router';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { CustomerPortfolioPage } from 'routes/vendor/lazy-imports';
// import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';

export const accountRoutes: RouteObject = {
  path: `${ROUTE_PATHS.ACCOUNTS}/${ROUTE_PATHS.MATCH_ALL}`,
  element: (
    <SecureRoute>
      <CustomerPortfolioPage />
    </SecureRoute>
  ),
  // async lazy() {
  //   const { CustomerPortfolioRoute } = await retryImportInsideRoutesDefinition(
  //     () => import('.'),
  //   );

  //   return {
  //     element: <CustomerPortfolioRoute />,
  //   };
  // },
};
